import React, { useState } from 'react';
import axios from 'axios';
import API_BASE from './config';
import { useNavigate, useLocation } from 'react-router-dom';

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const token = query.get('token');

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);

    const handleReset = async (e) => {
        e.preventDefault();
        if (password !== confirm) return alert("Passwords don't match");
        setLoading(true);
        try {
            const cleanBase = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
            await axios.post(`${cleanBase}/api/password_reset/confirm/`, {
                password: password,
                token: token,
            });
            alert("Password updated successfully!");
            navigate('/participant/login');
        } catch (err) {
            alert("Link expired or invalid token.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
            <div className="bg-white/[0.02] border border-white/[0.07] rounded-[2rem] p-8 w-full max-w-md">
                <h2 className="text-2xl font-black text-white uppercase mb-6">Create New Password</h2>
                <form onSubmit={handleReset} className="space-y-4">
                    <input
                        type="password" placeholder="New Password" required
                        className="w-full bg-black/40 border border-white/10 rounded-2xl px-4 py-3.5 text-white"
                        onChange={e => setPassword(e.target.value)}
                    />
                    <input
                        type="password" placeholder="Confirm New Password" required
                        className="w-full bg-black/40 border border-white/10 rounded-2xl px-4 py-3.5 text-white"
                        onChange={e => setConfirm(e.target.value)}
                    />
                    <button className="w-full bg-sky-500 text-black font-black py-4 rounded-2xl uppercase text-[11px]">
                        {loading ? 'Updating...' : 'Update Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;